module.exports = __webpack_public_path__ + "img/strap_length.7bb1e84e.png";